'use client';

import { useEffect } from 'react';

import { mountBrazeInit } from '../../utils/braze/init';
import { publicConfig } from '../../utils/config';

export default function Braze() {
  const {
    BRAZE: { API_KEY, SDK_ENDPOINT },
  } = publicConfig();

  useEffect(() => {
    if (!API_KEY || !SDK_ENDPOINT) return;

    return mountBrazeInit();
  }, [API_KEY, SDK_ENDPOINT]);

  return null;
}
